import type { FC } from 'react'

import type { VaultAllCategoriesInfo } from '@api'

import VaultAudioIcon from '@/assets/icons/icon-vault-audio.svg'
import VaultGifIcon from '@/assets/icons/icon-vault-gif.svg'
import VaultImageIcon from '@/assets/icons/icon-vault-image.svg'
import VaultVideoIcon from '@/assets/icons/icon-vault-video.svg'

export const MEDIA_TYPES: {
  key: keyof VaultAllCategoriesInfo
  icon: FC<React.SVGProps<SVGSVGElement>>
}[] = [
  { key: 'photosCount', icon: VaultImageIcon },
  { key: 'videosCount', icon: VaultVideoIcon },
  { key: 'audiosCount', icon: VaultAudioIcon },
  { key: 'gifsCount', icon: VaultGifIcon },
]
